const driversOnline = {
  driversOnline: 'נהגים מקוונים',

  table: {
    headers: {
      name: 'שם',
      phone: 'מספר טלפון',
      status: 'סטטוס',
      vehicle: 'רכב',
      activeSince: 'פעיל מאז',
      sum: 'סך הכל',
      pax: 'נוסעים',
      earned: 'הרוויח',
    },
    driverStatusOptions: {
      online: 'מקוון',
      enRoute: 'בנסיעה',
      break: 'הפסקה',
      endBreak: 'סיום הפסקה',
    },
    actions: {
      deactivate: 'השעיה',
    },
  },

  form: {
    fields: {
      driver: 'נהג',
      vehicle: 'רכב',
    },
    activateButton: 'עבור למצב מקוון',
  },

  deactivateModal: {
    header: 'השבת נהג',
    body: 'האם אתה בטוח שברצונך להשבית את {{driver}}?',
  },
  breakModal: {
    header: 'שלח נהג להפסקה',
    body: 'האם אתה בטוח שברצונך לשחרר את {{driver}} להפסקה?',
  },
};

export default driversOnline;
